
import { progressStart, progressEnd } from '@ibkr/lib.common/src/js/progress'
import { httpFailed, httpError, getHttpErrorReason } from '@ibkr/clientportal.common/src/js/http'
import { safeCall } from '@ibkr/clientportal.common/src/js/promise'
import { apiGet, apiPost, apiPut, apiGetAll } from '../../../api/default';

const FB_ROOT = "root";
const FB_LEVEL = 'level';
const FB_PARENT = 'parent';
const FB_ORDER = "order";
const FB_SEL = "sel";
const FB_TEXT = "text";

function processFeedbackData(fbData) {
    let done = false;
    
    let numIters = 0;
    const MAX_LEVELS = 3;
    while (!done) {
        numIters += 1;
        if (numIters > MAX_LEVELS) {
            // Don't hang up user's browser
            console.error("Unexpected FB data error.");
            break;
        }
        done = true;
        for (let i = 0; i < fbData.length; ++i) {
            const fb = fbData[i];
            if (fb.level) {
                continue;
            }
            if (fb.parentLabel == FB_ROOT) {
                fb[FB_LEVEL] = 1;
                fb[FB_ORDER] = Number(fb.rank) * Math.pow(10, MAX_LEVELS - fb.level + 1);
                fb[FB_SEL] = false;
                fb[FB_TEXT] = '';
                continue;
            }
            else {
                const parent = fbData.find(e => e.label == fb.parentLabel);
                if (parent && parent.level) {
                    fb[FB_PARENT] = parent;
                    fb[FB_LEVEL] = parent.level + 1;
                    fb[FB_ORDER] = parent.order + Math.pow(10, MAX_LEVELS - fb.level + 1) * Number(fb.rank);
                    fb[FB_SEL] = false;
                    fb[FB_TEXT] - '';
                    continue;
                }
            }
            done = false;
        }
    }

    fbData = fbData.sort(function(a, b) {
        return a.order < b.order ? -1 : 1;
    });
    return fbData;
}

export const deleteDeviceOption = ({ commit, dispatch, state }, { deviceId, deviceName, el, onSuccess, onError }) => {
    progressStart(el);
    apiPost('/fyi/deliveryoptions/device/delete', { deviceId })
        .then((res) => {
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onError) onError(getHttpErrorReason(result.response));
        httpFailed('delete device delivery option failed', commit, result)
    });
}

export const getDeliveryOptions = ({ commit, dispatch, state }, { conids, onSuccess, onError }) => {
    apiGet('/fyi/deliveryoptions')
        .then((res) => {
            commit('SET_FYI_DELIVERY_OPTIONS', res);
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            httpFailed("get fyi delivery options failed", commit, result);
            if (onError) onError(result);
        });
}

export const getFyiDisclaimer = ({ commit, dispatch, state }, { fc, onSuccess}) => {
    apiGet('/fyi/disclaimer/' + fc)
        .then((res) => {
            commit('SET_FYI_DISCLAIMER', res);
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            httpFailed("get fyi disclaimer failed", commit, result);
        });
}

export const getFyiSettings = ({ commit, dispatch, state }, { el, onSuccess, onError }) => {
    progressStart(el);
    apiGet('/fyi/settings')
        .then((res) => {
            commit('SET_FYI_SETTINGS', res);
            progressEnd(el);
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            if (onError) onError(result);
            progressEnd(el);
            httpFailed("get fyi settings failed", commit, result);
        });
}

export const getAllFyis = ({ commit, dispatch, state }, { id, el, onSuccess, onError }) => {
    progressStart(el);
    apiGet('/fyi/notifications' + (id ? '?id=' + id : ''))
        .then((res) => {
            commit('SET_FYI_NOTIFICATIONS', res);
            progressEnd(el);
            safeCall('get all fyi notifications', onSuccess, res);
        })
        .catch((result) => {
            progressEnd(el);
            safeCall('get all fyi notifications', onError, httpError(result));
            httpFailed("get all fyi notifications failed", commit, result);
        });
}

export const getFyiNotifications = ({ commit, dispatch, state }, { id, el, onSuccess, onError }) => {
    progressStart(el);
    apiGet('/fyi/notifications?exclude=UA&max=10' + (id ? '&id=' + id : ''))
        .then((res) => {
            commit('SET_FYI_NOTIFICATIONS', res);
            progressEnd(el);
            safeCall('get fyi notifications', onSuccess, res);
        })
        .catch((result) => {
            progressEnd(el);
            safeCall('get fyi notifications', onError, httpError(result));
            httpFailed("get fyi notifications failed", commit, result);
        });
}

export const getFyiAlerts = ({ commit, dispatch, stat }, { id, el, onSuccess }) => {
    progressStart(el);
    apiGet('/fyi/notifications?include=UA&max=10' + (id ? '&id=' + id : ''))
        .then((res) => {
            commit('SET_FYI_ALERTS', res);
            progressEnd(el);
            safeCall('get fyi alerts', onSuccess, res);
        })
        .catch((result) => {
            progressEnd(el);
            httpFailed("get fyi alerts failed", commit, result);
        });
}

export const getMoreFyiNotifications = ({ commit, dispatch, state }, { id, onSuccess }) => {
    apiGet('/fyi/notifications/more' + (id ? '?id=' + id : ''))
        .then((res) => {
            commit('SET_FYI_NOTIFICATIONS', res);
            safeCall('fyi notifications', onSuccess, res);
        })
        .catch((result) => {
            httpFailed("get more fyi notifications failed", commit, result);
        });
}

export const markDisclaimerRead = ({ commit, dispatch, state }, { fc, el, onSuccess, onError }) => {
    progressStart(el);
    apiPut('/fyi/disclaimer/' + fc)
        .then((res) => {
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onError) onError(httpError(result.response));
        httpFailed('mark disclamer read failed', commit, result)
    });
}

export const markNotificationRead = ({ commit, dispatch, state }, { n, el, onSuccess, onError }) => {
    progressStart(el);
    apiPut('/fyi/notifications/' + n.id)
        .then((res) => {
            commit('MARK_FYI_NOTIFICATION_READ', n);
            // reduce count of unread FYIs by 1
            commit('MARK_FYI_READ', 1);
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        safeCall('mark notification read', onError, httpError(result));
        httpFailed('mark notification read failed', commit, result)
    });
}

export const setDeviceOption = ({ commit, dispatch, state }, { option, i, el, onSuccess, onError }) => {
    progressStart(el);
    apiPost('/fyi/deliveryoptions/device', option)
        .then((res) => {
            commit('TOGGLE_FYI_DELIVERY_OPTION', i);
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onError) onError(getHttpErrorReason(result.response));
        httpFailed('change device delivery option failed', commit, result)
    });
}

export const setEmailOption = ({ commit, dispatch, state }, { enabled, el, onSuccess, onError }) => {
    progressStart(el);
    apiPut('/fyi/deliveryoptions/email?enabled=' + enabled)
        .then((res) => {
            commit('TOGGLE_FYI_EMAIL_OPTION');
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onError) onError(getHttpErrorReason(result.response));
        httpFailed('change email delivery option failed', commit, result)
    });
}

export const setNotificationSetting = ({ commit, dispatch, state }, { fc, enabled, i, el, onSuccess, onError }) => {
    progressStart(el);
    apiPost('/fyi/settings/' + fc, {'enabled': enabled})
        .then((res) => {
            commit('TOGGLE_FYI_SUBSCRIPTION', i);
            if (onSuccess) onSuccess();
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onError) onError(getHttpErrorReason(result.response));
        httpFailed('change notification setting', commit, result)
    });
}

export const submitReferralResponse = ({ commit, dispatch, state }, { el, json, onSuccess, onFailure }) => {
    progressStart(el);
    apiPost('/fyipub/refresponse', json)
        .then((res) => {
            if (onSuccess) onSuccess(res, json);
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onFailure) {
            onFailure(json);
        }
        httpFailed('Submit Referral response failed', commit, result);
    });
}

export const queryUserId = ({ commit, dispatch, state }, { el, id, onUserIdResp }) => {
    apiGet('/fyipub/userid/' + id)
        .then((res) => {
            if (onUserIdResp) {
                onUserIdResp(res);
            }
    })
    .catch((result) => {
        if (onUserIdResp) {
            onUserIdResp(result);
        }
        httpFailed('Query userId  failed', commit, result);
    });
}

export const getCountryCodes = ({ commit, dispatch, state }, {onSuccess}) => {
    if (state.countryCodes.length == 0) {
        apiGet('/ibcust/countries/list/')
            .then((res) => {
                const ccData = res.map(d => ({'label' : d.name, 'value': d.alpha3, 'callingCode': d.calling_code}));
                commit('SET_COUNTRY_CODES', ccData);
            });
    }
}

export const getFeedbackData = ({ commit, dispatch, state }, {forInvitee, onSuccess}) => {
    if (state.feedbackData.length == 0) {
        apiGet('/fyipub/' + (forInvitee ? 'inviteefbdata' : 'feedbackdata'))
            .then((res) => {
                const processedFBData = processFeedbackData(res);
                commit('SET_FEEDBACK_DATA', processedFBData);
                safeCall("getFeedbackData onSuccess", onSuccess);
            });
    }
}

export const submitFeedback = ({ commit, dispatch, state }, { el, isInvitee, json, onSuccess, onFailure }) => {
    progressStart(el);
    apiPost('/fyipub/' + (isInvitee ? 'inviteefeedback' : 'reffeedback'), json)
        .then((res) => {
            if (onSuccess) onSuccess(res, json);
            progressEnd(el);
    })
    .catch((result) => {
        progressEnd(el);
        if (onFailure) {
            onFailure(json);
        }
        httpFailed('Submit feedback failed', commit, result);
    });
}


export const getUnreadFyiNum = ({ commit, dispatch, state }, {}) => {
    return new Promise((resolve, reject) => {
        apiGet('/fyi/unreadnumber')
            .then((res) => {
                if (res.BN !== undefined) {
                    commit('SET_UNREAD_FYI_NUM', res.BN);
                    resolve(res);
                } else {
                    reject(`Missing BN attribute in response: ${res}`);
                }
            })
            .catch((err) => {
                reject(err)
                httpFailed('Get unread fyi num failed', commit, err);
            });
    });
}

export const getFyisAndTradeAlerts = ({ commit, dispatch, state }, {}) => {
    return new Promise((resolve, reject) => {
        apiGetAll([
            '/fyi/notifications?exclude=UA&max=10',
            '/fyi/notifications?include=UA&max=10'
        ])
            .then(res => {
                commit('SET_FYI_NOTIFICATIONS', res[0]);
                commit('SET_FYI_ALERTS', res[1]);
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export const storeUnsavedPriceAlerts = ({ commit, state }, { flag }) => {
    commit('SET_UNSAVED_PRICE_ALERTS', flag);
}
